b {
  font-weight: 500;
}
